import { Reveal } from "@/components/Reveal";

const STATS = [
    { value: "Since 2007", label: "Weddings & world events", testId: "trust-stat-1" },
    { value: "Hundreds", label: "Of weddings played", testId: "trust-stat-2" },
    { value: "Beverly Hills", label: "Based, at home in Los Angeles", testId: "trust-stat-3" },
    { value: "Worldwide", label: "Destination weddings & events", testId: "trust-stat-4" },
];

export const TrustStrip = () => (
    <section data-testid="trust-strip" className="border-y border-white/10 bg-[#0c0c0f]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid grid-cols-2 lg:grid-cols-4 gap-10">
            {STATS.map((s, i) => (
                <Reveal key={s.testId} delay={i * 0.1}>
                    <div data-testid={s.testId}>
                        <p className="font-serif text-2xl md:text-3xl text-[#d4af37] font-light">{s.value}</p>
                        <p className="mt-2 text-xs uppercase tracking-[0.2em] text-[#a1a1aa]">{s.label}</p>
                    </div>
                </Reveal>
            ))}
        </div>
    </section>
);
